export class EscPosEncoder {

    constructor() {

        this.buffer = [];

    }

    // Add raw bytes

    raw(bytes) {

        this.buffer.push(...bytes);

        return this;

    }

    // New line

    newline(n = 1) {

        for (let i = 0; i < n; i++) this.buffer.push(0x0a);

        return this;

    }

    // Reset printer

    reset() {

        return this.raw([0x1b, 0x40]);

    }

    // Text

    text(content) {

        const encoder = new TextEncoder();

        this.buffer.push(...encoder.encode(content));

        return this;

    }

    // Bold ON/OFF

    bold(on = true) {

        return this.raw([0x1b, 0x45, on ? 1 : 0]);

    }

    // Align: left, center, right

    align(mode = "left") {

        let val = 0;

        if (mode === "center") val = 1;

        if (mode === "right") val = 2;

        return this.raw([0x1b, 0x61, val]);

    }

    // Cut paper

    cut() {

        return this.raw([0x1d, 0x56, 0x41, 10]);

    }

    // Feed n lines

    feed(n = 3) {

        return this.raw([0x1b, 0x64, n]);

    }

    // Get final ArrayBuffer

    encode() {

        return new Uint8Array(this.buffer).buffer;

    }

}